import { getCompareItems, removeCompareItem, clearCompareItems, setWidgetMinimized, getWidgetMinimized } from './comparador-storage.js';

export default function initCompareWidget() {
    const widget = document.querySelector('.c-compare-widget');
    if (!widget) return;

    const track = widget.querySelector('.c-compare-widget__track');
    const btnMinimize = widget.querySelector('.c-compare-widget__btn-minimize');
    const btnReturn = widget.querySelector('.c-compare-widget__btn-return');
    const btnClose = widget.querySelector('.c-compare-widget__btn-close');
    const btnClear = widget.querySelector('.c-compare-widget__btn-clear');
    const btnCompare = widget.querySelector('.c-compare-widget__btn-compare');
    const fallbackImage = widget.getAttribute('data-fallback-image') || '';

    const COMPARE_PAGE_URL = '/comparador';

    if (window.location.pathname.includes(COMPARE_PAGE_URL)) {
        // Remove a classe do widget ou aplica display none
        widget.style.display = 'none';
        return;
    }

    // Pegar estado inicial do localStorage
    let isUserMinimized = getWidgetMinimized();

    function renderWidget() {
        const items = getCompareItems();

        // 1. Se não tem produtos, garante que o widget suma
        if (items.length === 0) {
            widget.classList.remove('c-compare-widget--is-expanded', 'c-compare-widget--is-minimized');
            return;
        }

        // 2. FORÇAR ESTADO SEGUNDO O STORAGE
        // Em vez de checar se contém a classe, nós aplicamos a classe baseada 
        // no isUserMinimized toda vez que a função roda ou a página carrega.
        if (isUserMinimized) {
            widget.classList.add('c-compare-widget--is-minimized');
            widget.classList.remove('c-compare-widget--is-expanded');
        } else {
            widget.classList.add('c-compare-widget--is-expanded');
            widget.classList.remove('c-compare-widget--is-minimized');
        }

        // 3. Construção do HTML
        let htmlBuffer = '';

        for (let i = 0; i < 3; i++) {
            if (items[i]) {
                const itemImage = items[i].image || fallbackImage;

                htmlBuffer += `
                    <div class="c-compare-widget__slot">
                        <article class="c-compare-widget__item">
                            <button type="button" class="c-compare-widget__delete js-widget-delete" data-id="${items[i].id}" aria-label="Remover produto">
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<rect width="21" height="21" fill="url(#pattern0_4281_14447)"/>
<defs>
<pattern id="pattern0_4281_14447" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_4281_14447" transform="scale(0.0078125)"/>
</pattern>
<image id="image0_4281_14447" width="128" height="128" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
</defs>
</svg>    
                            </button>
                            <a href="${items[i].link}" class="c-compare-widget__card">
                                <div class="c-compare-widget__image-wrapper">
                                    <img src="${itemImage}" alt="${items[i].title}" loading="lazy">
                                </div>
                                <h3 class="c-compare-widget__title">${items[i].title}</h3>
                            </a>
                        </article>
                    </div>`;
            } else {
                let message = '';
                if (items.length === 1 && i === 1) {
                    message = 'Navegue pelo site e selecione ao menos mais um produto para comparar';
                } else if (items.length === 2 && i === 2) {
                    message = 'Você pode comparar com mais um item.';
                }

                htmlBuffer += `
                    <div class="c-compare-widget__slot c-compare-widget__slot--empty">
                        ${message ? `<p class="c-compare-widget__message">${message}</p>` : ''}
                    </div>`;
            }
        }

        track.innerHTML = htmlBuffer;

        // 3. Controle do botão de ação
        btnCompare.disabled = items.length < 2;
    }

    // ==========================================
    // 2. EVENT LISTENERS
    // ==========================================

    btnMinimize.addEventListener('click', () => {
        isUserMinimized = true;
        setWidgetMinimized(true);
        widget.classList.remove('c-compare-widget--is-expanded');
        widget.classList.add('c-compare-widget--is-minimized');
    });

    btnReturn.addEventListener('click', () => {
        isUserMinimized = false;
        setWidgetMinimized(false);
        widget.classList.remove('c-compare-widget--is-minimized');
        widget.classList.add('c-compare-widget--is-expanded');
    });

    btnClose.addEventListener('click', () => clearCompareItems());
    btnClear.addEventListener('click', () => clearCompareItems());

    btnCompare.addEventListener('click', () => {
        if (!btnCompare.disabled) {
            window.location.href = COMPARE_PAGE_URL;
        }
    });

    track.addEventListener('click', (e) => {
        const deleteBtn = e.target.closest('.js-widget-delete');
        if (deleteBtn) {
            const id = deleteBtn.getAttribute('data-id');
            removeCompareItem(id);
        }
    });

    renderWidget();
    document.addEventListener('pdrCompareUpdated', renderWidget);
}
